import React from 'react'
import { BlueBtn, Presale } from './styles'
import { SEASON_SEGMENT_NAMES, getShortMarket, logEvent } from '../../../../../../Utils'
import { EventGQL } from '../../../../../../Api'
import { MAIN_PLL_URL, PLL_LINKS } from '../../../../../../Config/config'
import { logBrazeEvent } from '../../../../../../Utils/Analytics/brazeAnalytics'
import { marketPresales } from '../../../../../../Config/Season/season'
import { ANALYTICS_TAGS } from '../../../../../../Constants/analytics'
import { Lk } from '../../../../../../Components/Links/Lk'

type TicketDropdownType = {
  event: EventGQL
  week: string
  weekendUrl?: string
  waitList: boolean
  dayTickets: DayTicketsType[]
  market: string
}

type DayTicketsType = {
  date: string
  ticketUrl: string
  ticketId: string
}

export const TicketsButton: React.FC<React.PropsWithChildren<TicketDropdownType>> = ({
  event,
  week,
  waitList,
  market,
}) => {
  let shortMarket = getShortMarket(event)

  const createTicketsLink = () => {
    if (event.seasonSegment === SEASON_SEGMENT_NAMES.champseries) {
      return PLL_LINKS.championshipSeriesTickets
    }
    if (event.seasonSegment === SEASON_SEGMENT_NAMES.post) {
      shortMarket = getShortMarket(event)
    }
    if (waitList) return marketPresales[shortMarket.toLowerCase()]
    return shortMarket
      ? `https://${MAIN_PLL_URL}/${shortMarket.toLowerCase()}?source=Schedule_Page`
      : ''
  }
  const log = (name: string, params: any) => {
      logEvent(name, params)
      logBrazeEvent(name, params)
  }

  return (
    <>
      {waitList && (
        <>
          <Presale
            href={event.waitlistUrl}
            target="_blank"
            rel="noreferrer noopener"
            aria-label="Join Presale"
          >
            <BlueBtn
              onClick={() =>
                log(ANALYTICS_TAGS.tickets_click, {
                  week: `${week}`,
                  status: 'presale',
                  market: shortMarket,
                  ticketUrl: event.waitlistUrl,
                })
              }
            >
              Join Presale
            </BlueBtn>
          </Presale>
        </>
      )}
      {!waitList && (
        <>
          <Lk link={createTicketsLink()} alt={`${week} - ${market} - Tickets`}>
            <BlueBtn
              onClick={() =>
                log(ANALYTICS_TAGS.tickets_click, {
                  week: `${week}`,
                  market: shortMarket,
                  ticketUrl: createTicketsLink(),
                })
              }
            >
              Tickets
            </BlueBtn>
          </Lk>
        </>
      )}
    </>
  )
}
